import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useQuery } from '@tanstack/react-query'
import { CasesHomeFn } from '../api/getCasesHome'

interface AnimatedPortfolioProps {
 ch_id: number
 ch_number: number
 ch_link: string
 ch_name: string
 ch_seo: string
 ch_cliente_name: string
 ch_title: string
 ch_aos: string
 ch_status: number
}

export function AnimatedPortfolio() {
 useEffect(() => {
  AOS.init()
 }, [])

 const { data: cases } = useQuery<AnimatedPortfolioProps[]>({
  queryKey: ['casesHome'],
  queryFn: CasesHomeFn,
  staleTime: 1000 * 60 * 60 * 24 // 1 dia
 })

 return (
  <div className="flex flex-wrap">
   {cases
    ?.filter(caseHomeNumber => caseHomeNumber.ch_number === 1)
    .map(caseHome => {
     return (
      <div
       className="w-full max-[575px]:w-full min-[576px]:w-full min-[768px]:w-[240px] min-[992px]:w-2/3 max-[992px]:px-0 px-4 animate-move-up-down remove-animation"
       key={caseHome.ch_id}
      >
       <div
        className="w-full h-auto max-[575px]:w-full max-[768px]:w-full max-[768px]:h-auto max-[992px]:w-[240px] max-[992px]:h-[240px] group no-hover-filter"
        data-aos={caseHome.ch_aos}
       >
        <a href={`/${caseHome.ch_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {caseHome.ch_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-xl text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {caseHome.ch_title}
         </span>
         <div className="relative w-full aspect-[808/564] max-[992px]:aspect-auto max-[992px]:h-[240px] max-[768px]:h-[270px]">
          <img
           src={`https://www.admancriativa.com.br/assets/img/cases/${caseHome.ch_name}`}
           alt={caseHome.ch_seo}
           title={caseHome.ch_seo}
           className="w-full h-full object-cover group-hover:grayscale group-hover:brightness-50"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
   {cases?.some(caseHomeNumber => caseHomeNumber.ch_number === 2) && (
    <div className="w-full max-[575px]:w-full min-[576px]:w-[540px] min-[768px]:w-[480px] min-[992px]:w-1/3 flex flex-col max-[992px]:flex-row max-[575px]:flex-col items-end max-[992px]:px-0 px-4 animate-move-up-down remove-animation">
     {cases
      .filter(caseHomeNumber => caseHomeNumber.ch_number === 2)
      .map(caseHome => {
       return (
        <div
         key={caseHome.ch_id}
         className="w-[314px] h-[314px] max-[575px]:w-full max-[575px]:h-auto max-[768px]:w-[270px] max-[768px]:h-[270px] max-[992px]:w-[240px] max-[992px]:h-[240px] max-[992px]:mb-0 max-[992px]:flex-shrink-0 max-[1200px]:w-[274px] max-[1200px]:h-[274px] mb-14 max-[1200px]:mb-8 group no-hover-filter"
         data-aos={caseHome.ch_aos}
        >
         <a href={`/${caseHome.ch_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {caseHome.ch_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-xl text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {caseHome.ch_title}
          </span>
          <div className="relative w-full aspect-[314/314] max-[992px]:aspect-auto max-[992px]:h-[240px] max-[768px]:h-[270px]">
           <img
            src={`https://www.admancriativa.com.br/assets/img/cases/${caseHome.ch_name}`}
            alt={caseHome.ch_seo}
            title={caseHome.ch_seo}
            className="w-full h-full object-cover group-hover:grayscale group-hover:brightness-50"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {cases?.some(caseHomeNumber => caseHomeNumber.ch_number === 3) && (
    <div className="w-full max-[575px]:w-full min-[576px]:w-[540px] min-[768px]:w-[480px] min-[992px]:w-1/3 flex flex-col max-[992px]:flex-row max-[575px]:flex-col items-end max-[992px]:px-0 px-4 animate-move-up-down remove-animation">
     {cases
      .filter(caseHomeNumber => caseHomeNumber.ch_number === 3)
      .map(caseHome => {
       return (
        <div
         key={caseHome.ch_id}
         className="w-[314px] h-[314px] max-[575px]:w-full max-[575px]:h-auto max-[768px]:w-[270px] max-[768px]:h-[270px] max-[992px]:w-[240px] max-[992px]:h-[240px] max-[992px]:mb-0 max-[992px]:flex-shrink-0 max-[1200px]:w-[274px] max-[1200px]:h-[274px] mb-14 max-[1200px]:mb-8 group no-hover-filter"
         data-aos={caseHome.ch_aos}
        >
         <a href={`/${caseHome.ch_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {caseHome.ch_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-xl text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {caseHome.ch_title}
          </span>
          <div className="relative w-full aspect-[314/314] max-[992px]:aspect-auto max-[992px]:h-[240px] max-[768px]:h-[270px]">
           <img
            src={`https://www.admancriativa.com.br/assets/img/cases/${caseHome.ch_name}`}
            alt={caseHome.ch_seo}
            title={caseHome.ch_seo}
            className="w-full h-full object-cover group-hover:grayscale group-hover:brightness-50"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {cases
    ?.filter(caseHomeNumber => caseHomeNumber.ch_number === 4)
    .map(caseHome => {
     return (
      <div
       className="w-full max-[575px]:w-full min-[576px]:w-full min-[768px]:w-[240px] min-[992px]:w-2/3 max-[992px]:px-0 px-4 animate-move-up-down remove-animation"
       key={caseHome.ch_id}
      >
       <div
        className="w-full h-auto max-[575px]:w-full max-[768px]:w-full max-[768px]:h-auto max-[992px]:w-[240px] max-[992px]:h-[240px] group no-hover-filter"
        data-aos={caseHome.ch_aos}
       >
        <a href={`/${caseHome.ch_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {caseHome.ch_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-xl text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {caseHome.ch_title}
         </span>
         <div className="relative w-full aspect-[808/564] max-[992px]:aspect-auto max-[992px]:h-[240px] max-[768px]:h-[270px]">
          <img
           src={`https://www.admancriativa.com.br/assets/img/cases/${caseHome.ch_name}`}
           alt={caseHome.ch_seo}
           title={caseHome.ch_seo}
           className="w-full h-full object-cover group-hover:grayscale group-hover:brightness-50"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
  </div>
 )
}
